module.exports = {
  DEBUG: true,
  APP_ENV: 'local',
  API_URL: 'http://localhost:5000/api'
  // more env vars here
}



// WEBPACK FOOTER //
// ./src/env/local.js